var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"main-header"},[_c('Header',{on:{"openRespMenu":_vm.openRespMenu}}),_c('MainSearch'),_c('RespLoginModal'),_c('CartLists'),_c('RespMenu',{ref:"respMenu"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }